<template>
  <div class="card border-0">
    <div class="card-heading bg-light">
      <h2 class="text-center mt-3 mb-3">
        <i class="fa fa-flask" aria-hidden="true"></i> Test de referencias
      </h2>
    </div>
    <div class="card-body px-0" v-loading="loadingDecodeRef">
      <form
        role="search"
        class="form-inline d-flex"
        v-on:submit.prevent="decodeRef(referencia)"
      >
        <input type="text" class="form-control" placeholder="Mateo 17,6-7" v-model="referencia">
        <button type="submit" class="btn btn-light" :disabled="decodeDisabled">Probar</button>
      </form>
      <p class="text-secondary mt-3" v-if="resultados.length > 0">{{resultados}}</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { APIENDPOINT } from "@/backend";

export default {
  data() {
    return {
      loadingDecodeRef: false,
      referencia: "",
      mensaje: "",
      resultados: ""
    };
  },
  watch: {
    referencia: function() {
      this.mensaje = "";
      this.resultados = "";
    }
  },

  created: function() {},

  methods: {
    decodeRef: function(referencia) {
      var app = this;
      app.mensaje = "Buscando...";
      app.loadingDecodeRef = true;
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/bible",
        params: { ref: referencia }
      })
        .then(function(response) {
          // console.log(response);
          app.loadingDecodeRef = false;
          if (response.data.code === 4) {
            app.mensaje = "";
            app.resultados = response.data.description;
          } else {
            app.mensaje = "Resultados";
            app.resultados = response.data.data.verses;
          }
        })
        .catch(function(error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error);
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            app.mensaje = error.request;
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
        });
    }
  },

  computed: {
    decodeDisabled() {
      if (this.referencia.length < 6) {
        this.resultados = "Mínimo 6 caracteres..";
        return true;
      }
    }
  }
};
</script>
